import type { SortOption } from './types';

export const getSortQuery = (sortItems: SortOption[]): string | undefined => {
  if (sortItems.length === 0) {
    return undefined;
  }
  return sortItems
    .map((sortItem) => `${sortItem.name},${sortItem.order}`)
    .join(';');
};
